"use client";

import React, { useEffect, useState } from "react";
import { useParams } from "next/navigation";
import CourseDetailTemplate from "@/components/courses/course-detail/CourseDetailTemplate";
import coursedetails from "@/app/premium-courses/courdetails";

const CourseDetailPage = () => {
  const params = useParams();
  const { slug } = params;
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Find the course by slug
    const foundCourse = coursedetails.find(course => course.slug === slug);
    setCourse(foundCourse);
    setLoading(false);
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!course) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Course Not Found</h1>
        <p className="text-gray-600">The course you're looking for doesn't exist or has been removed.</p>
      </div>
    );
  }

  return <CourseDetailTemplate courseData={course} />;
};

export default CourseDetailPage; 